import { useTranslation } from 'next-i18next';
import { MainAwards } from './MainAwards';
import { SubAwards } from './SubAwards';
export const BizAward = () => {
  return <section className="flex flex-col items-center justify-center gap-lg px-md pb-2xl pt-3xl mobile-lg:px-lg tablet-lg:px-2xl" data-sentry-component="BizAward" data-sentry-source-file="BizAward.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="BizAward.tsx" />
      <Awards data-sentry-element="Awards" data-sentry-source-file="BizAward.tsx" />
    </section>;
};
const Title = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  return <div className="flex flex-col items-center gap-sm" data-sentry-component="Title" data-sentry-source-file="BizAward.tsx">
      <span className="text-center text-display-sm-extrabold">
        {t('biz-landing.award.title')}
      </span>
      <span className="text-center text-body-lg-semibold text-neutral">
        {t('biz-landing.award.description')}
      </span>
    </div>;
};
const Awards = () => {
  return <div className="my-md flex w-full flex-col gap-xl pt-[30px] tablet-sm:max-w-[964px] tablet-sm:pt-[36px]" data-sentry-component="Awards" data-sentry-source-file="BizAward.tsx">
      <MainAwards data-sentry-element="MainAwards" data-sentry-source-file="BizAward.tsx" />
      <SubAwards data-sentry-element="SubAwards" data-sentry-source-file="BizAward.tsx" />
    </div>;
};